import {Avatar, Breadcrumb, Button, List, Skeleton} from 'antd';
import React, {useEffect, useState} from 'react';
import {BellOutlined} from "@ant-design/icons";

const count = 12;
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat,picture&noinfo`;


const NotificationComponent = () => {
    const [initLoading, setInitLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [list, setList] = useState([]);
    useEffect(() => {
        fetch(fakeDataUrl)
            .then((res) => res.json())
            .then((res) => {
                setInitLoading(false);
                setData(res.results);
                setList(res.results);
            });
    }, []);

    const onLoadMore = () => {
        setLoading(true);
        setList(
            data.concat(
                [...new Array(count)].map(() => ({
                    loading: true,
                    name: {},
                    picture: {},
                })),
            ),
        );
        fetch(fakeDataUrl)
            .then((res) => res.json())
            .then((res) => {
                const newData = data.concat(res.results);
                setData(newData);
                setList(newData);
                setLoading(false);

                window.dispatchEvent(new Event('resize'));
            });
    };

    const loadMore =
        !initLoading && !loading ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                }}
            >
                <Button onClick={onLoadMore}>Загрузить еще</Button>
            </div>
        ) : null;
    return (
        <>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <BellOutlined />
                        <span>Уведомления</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div style={{width: 800, marginLeft: 'auto', marginRight: 'auto'}}>
                <List
                    className="demo-loadmore-list"
                    loading={initLoading}
                    itemLayout="horizontal"
                    loadMore={loadMore}
                    dataSource={list}
                    renderItem={(item) => (
                        <List.Item
                        >
                            <Skeleton avatar title={false} loading={item.loading} active>
                                <List.Item.Meta
                                    avatar={<Avatar src={item.picture.large}/>}
                                    title={item.name?.last}
                                    description='Закончил проведение испытание на ОИ "Программное обеспечение
                                    искусственного интеллекта "Железный человек" Военно-воздушных сил Соединенных Штатов Америки"'
                                />
                            </Skeleton>
                        </List.Item>
                    )}
                />
            </div>
        </>
    );
};

export default NotificationComponent;
